import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'tsnedMarker'
})
export class TSNedMarkerPipe implements PipeTransform {

    transform(size = 25) {
        return {
            url: '/assets/logo/arrow-down.svg',
            scaledSize: {width: size, height: size} as google.maps.Size
        };
    }

}
